import { Mail, ArrowLeft } from 'lucide-react';

export function PasswordSentPage({ onNavigate }: { onNavigate: (page: string) => void }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-app-bg p-4">
      <div className="w-full max-w-[24rem] flex flex-col items-center text-center">
        <div className="w-16 h-16 rounded-full bg-violet-100 flex items-center justify-center mb-4">
          <Mail className="h-8 w-8 text-violet-600" />
        </div>
        <h1 className="text-3xl font-bold text-zinc-900">Revisa tu correo</h1>
        <p className="text-zinc-500 mt-2 mb-6">
          Te enviamos instrucciones para restablecer tu contraseña. Revisa tu bandeja de entrada y
          sigue el enlace del email.
        </p>
        <p className="text-zinc-400 text-sm mb-6">
          Si no recibes el email en unos minutos, revisa tu carpeta de spam.
        </p>
        <button
          type="button"
          onClick={() => onNavigate('login')}
          className="flex items-center gap-1.5 text-sm text-violet-600 hover:text-violet-700 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Volver al login
        </button>
      </div>
    </div>
  );
}
